var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col sm:flex-row w-full flex-wrap",class:_vm.centered ? 'sm:justify-center' : ''},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }